import React  from "react";
import MonthlyInvoiceForm from "./components/MonthlyInvoiceForm";
import { useSearchParams } from "react-router-dom";

const CreateInvoice = () => {

	const [searchParams] = useSearchParams();
	const invoiceType = searchParams.get("type");

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
			{ invoiceType === 'monthly' && 
				<MonthlyInvoiceForm recordId={0} mode="edit"/>
			}
	      </div>
	    </div>
    );
};

export default CreateInvoice;